import React, { Component } from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'
import { TitleBar } from '../../components'
import Card from '@mui/material/Card'
import Paper from '@mui/material/Paper'
import { connect } from 'react-redux'
import { 
  TimesheetActions, ProjectActions, CustomerActions, 
  UserActions, SnackBarActions, LabelActions,
} from '../../actionsets'
import { TimesheetSummary, TimesheetWeeklySummary, TimesheetTaskSummary, TimesheetFilter } from '.'
import { ModelStatus } from '../../constants'
import { RequestService } from '../../services'
import { TimesheetEntryAPI } from '../../api'
import { downloadContent } from '../../utils'

export class Timesheets extends Component{

  static propTypes = {
    dispatch: PropTypes.func,
    mode: PropTypes.string,
    timesheets: PropTypes.array.isRequired,
    requestingTimesheets: PropTypes.bool.isRequired,
    user: PropTypes.object.isRequired,
    users: PropTypes.array.isRequired,
    projects: PropTypes.array.isRequired,
    customers: PropTypes.array.isRequired,
  }

  static styles = {

  }

  constructor(props){
    super(props)

    TimesheetActions.bindActions(this)
    ProjectActions.bindActions(this)
    CustomerActions.bindActions(this)
    UserActions.bindActions(this)
    LabelActions.bindActions(this)
    SnackBarActions.bindActions(this)

  }

  componentDidMount = () => {
    this.actions.searchUsers({status: ModelStatus.active})
    this.actions.searchProjects({status: ModelStatus.active})
    this.actions.searchCustomers({status: ModelStatus.active})
  }

  loadTimesheets = filterParams => {
    this.actions.searchTimesheets(filterParams)
  }

  downloadTimesheetEntriesCSV = async filterParams => {
    try {
      this.actions.alert('Downloading as CSV..')
      let csv = await TimesheetEntryAPI.csv(filterParams)(RequestService)
      let filename = `timesheet_entries_${moment(filterParams.startDate).format('MMMM_DD')}_${moment(filterParams.endDate).format('MMMM_DD_YYYY')}.csv`
      downloadContent(csv.text, filename)
    }

    catch(e) {
      this.actions.alert('The file could not be downloaded')
    }
  }

  onApprove = timesheet => {
    const { startDate, endDate, user } = timesheet.attributes
    this.actions.approveTimesheet(user.id, startDate, endDate)
  }

  onUnapprove = timesheet => {
    const { startDate, endDate, user } = timesheet.attributes
    this.actions.unapproveTimesheet(user.id, startDate, endDate)
  }

  onLabelsSuggestionsFetchRequested = async (text, callback) => {
    const labels = await this.actions.searchLabels({name: text})
    const options = labels.sort(
      (a, b) => (a.attributes['name'] > b.attributes['name']) ? 1 : -1
    ).map(
      ({id, attributes: { name }}) => (name)
    )

    callback(options)
  }

  get mode() {
    return this.props.mode
  }

  renderTimesheetSummary = (timesheet, approver) => {
    if (timesheet?.attributes?.summary?.groupBy === 'week') {
      return <TimesheetWeeklySummary key={timesheet.id} timesheet={timesheet} />
    } else if (timesheet?.attributes?.summary?.groupBy === 'task') {
      return <TimesheetTaskSummary key={timesheet.id} timesheet={timesheet} />
    } else {
      return <TimesheetSummary
        key={timesheet.id}
        timesheet={timesheet}
        approver={approver}
        projects={this.props.projects}
        disableActions={this.mode !== 'approval' || !timesheet.attributes.summary.canApprove}
        onApprove={() => this.onApprove(timesheet)}
        onUnapprove={() => this.onUnapprove(timesheet)}
      />
    }
  }

  render = () => {
    const { timesheets, user, users, projects, customers } = this.props
    const totals = timesheets.reduce((totals, {attributes: {summary: { internalTime, externalTime }}}) => ({
      internalTime: internalTime + totals.internalTime,
      externalTime: externalTime + totals.externalTime
    }), { internalTime: 0, externalTime: 0 })

    return (
      <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
        <TitleBar>{this.mode === 'approval' ? 'Timesheet Approval' : 'Timesheets'}</TitleBar>
        <div style={{padding: 10}}>

          <TimesheetFilter
            onChange={this.loadTimesheets}
            onDownload={this.downloadTimesheetEntriesCSV}
            users={users}
            projects={projects}
            customers={customers}
            onLabelsSuggestionsFetchRequested={this.onLabelsSuggestionsFetchRequested}
            mode={this.mode}
          />

          {['user', 'project'].includes((timesheets || [])[0]?.attributes?.summary?.groupBy) &&
            <div style={{margin: '1em 0', color: 'gray', fontSize: '0.9em'}}>
              <span>Internal Hours: {totals.internalTime}</span>
              <span style={{marginLeft: '1em'}}>External Hours: {totals.externalTime}</span>
            </div>
          }

          {timesheets.map(ts => ts.attributes.summary.items.length > 0 && this.renderTimesheetSummary(ts, user))}

        </div>
      </div>
    )
  }
}

export default connect(
  ({session, timesheet, user, projects, customers, labels}) => { 
    return {...timesheet, ...user, ...projects, ...customers, ...labels, ...session}
  }
)(Timesheets)

